// tslint:disable:max-line-length

import React from 'react';

export const LayoutList = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M3,12v3H0v-3H3z M16,12v3H5v-3H16z M3,6v3H0V6H3z M16,6v3H5V6H16z M3,0v3H0V0H3z M16,0v3H5V0H16z" />
    </svg>
  );
};
